import React from "react";
import "css-doodle";

export default ({ rule = "" }) => <css-doodle>{rule}</css-doodle>;